import { Fragment, useContext, useState } from "react";
import Moment from "moment";
import QuizMCQExamService from "../../../../services/QuizMCQExamService";
import AuthContext from '../../../../auth/AuthContext';
import AlertService from "../../../../services/AlertService";
import ConfirmDialogBox from "../../../confirmDialog/ConfirmDialogBox";
import { ThemeContext } from "../../../../theme/ThemeContext";

const MCQSessionCard = ({ id, data, refreshHandler }) => {
    const authContext = useContext(AuthContext);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const { theme } = useContext(ThemeContext);
    const isDark = theme === "dark";

    const onConfirmDeleteHandler = (event) => {
        event.preventDefault();
        setShowDeleteDialog(true);
    };

    const deleteHandler = async () => {
        let result = await QuizMCQExamService.RemoveSession(id, data.userId, authContext);
        if (result.isSuccess) {
            AlertService.success("Session details are deleted successfully!! Please ask the user to restart the exam.");
            refreshHandler();
        } else {
            AlertService.error(result.errorMessage);
        }
    };

    return (
        <Fragment>
            <div className="card border-0 shadow-sm h-100 rounded-0">
                <div className="title fw-bold text-center pt-4" style={{ color: isDark ? "#2A96B8" : "#0D3744" }}>{data.attendeeName}</div>
                <div className="score-container pt-4 mb-3">
                    <center>
                        <span>
                            <label className="score">
                                {Moment(Moment.utc(data.startDate).toDate()).format("DD/MM/YYYY hh:mm:ss A")}
                            </label>
                        </span>
                    </center>
                </div>
                <div   style={{ backgroundColor: isDark ? "#252527" : "#F8FAFC" }} className="p-2">
                    <center>
                        <span>
                            <button className="text-danger"
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    cursor: 'pointer',
                                    font: 'inherit'
                                }} onClick={onConfirmDeleteHandler}>
                                <i className="pi pi-trash"></i> Kill Session
                            </button>
                        </span>
                    </center>
                </div>
            </div>
            <ConfirmDialogBox
                visible={showDeleteDialog}
                onHide={() => setShowDeleteDialog(false)}
                onConfirm={() => {
                    setShowDeleteDialog(false);
                    deleteHandler();
                }}
                title={
                    <>Are you sure you want to <strong>delete</strong> this session?</>
                }
                confirmLabel="Yes, Delete"
                cancelLabel="Cancel"
            />

        </Fragment>
    );
};

export default MCQSessionCard;
